<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='首页'"></div>
    <!--用户信息背景-->
    <div class="h_user_msg_bg">
      <div class="h_user_msg_box">{{ scanDetail }}</div>
    </div>
    <!--用户信息-->
    <div class="h_user_msg_d_bg">
      <div class="h_user_header"></div>
      <div class="h_user_msg_d_box">
        <p class="h_user_name">{{ userMsg.name }}</p>
        <p class="h_user_pos">{{ userMsg.role_name }}</p>
      </div>
    </div>
    <!--扫码-->
    <div class="h_fun_list_bg">
      <div class="h_fun_list_box">
        <!--标题-->
        <p>{{ orderData }}</p>
        <div class="h_fun_list_title">
          <p>扫码</p>
        </div>
        <!--九宫格-->
        <div class="h_fun_list_w">
          <!--扫码查询-->
          <div class="h_fun_list" @click="scanCode('0')">
            <div class="h_fun_list_icon l_i_3"></div>
            <p>扫码查询</p>
          </div>
          <!--针车中仓入库-->
          <div class="h_fun_list" v-show="pos.indexOf('1') != -1" @click="scanCode('1')">
            <div class="h_fun_list_icon l_i_1"></div>
            <p>针车中仓入库</p>
          </div>
          <!--针车中仓出库-->
          <div class="h_fun_list" v-show="pos.indexOf('2') != -1" @click="scanCode('2')">
            <div class="h_fun_list_icon l_i_2"></div>
            <p>针车中仓出库</p>
          </div>
          <!--成型中仓入库-->
          <div class="h_fun_list" v-show="pos.indexOf('3') != -1" @click="scanCode('3')">
            <div class="h_fun_list_icon l_i_4"></div>
            <p>成型中仓入库</p>
          </div>
          <!--成型中仓出库-->
          <div class="h_fun_list" v-show="pos.indexOf('4') != -1" @click="scanCode('4')">
            <div class="h_fun_list_icon l_i_5"></div>
            <p>成型中仓出库</p>
          </div>
          <!--成品库入库-->
          <div class="h_fun_list" v-show="pos.indexOf('5') != -1" @click="scanCode('5')">
            <div class="h_fun_list_icon l_i_6"></div>
            <p>成品库入库</p>
          </div>
          <!--针车品管扫码-->
          <div class="h_fun_list" v-show="pos.indexOf('6') != -1" @click="scanCode('6')">
            <div class="h_fun_list_icon l_i_7"></div>
            <p>针车品管扫码</p>
          </div>
          <!--成型品管扫码-->
          <div class="h_fun_list" v-show="pos.indexOf('7') != -1" @click="scanCode('7')">
            <div class="h_fun_list_icon l_i_8"></div>
            <p>成型品管扫码</p>
          </div>
          <!--装配品管扫码-->
          <div class="h_fun_list" v-show="pos.indexOf('8') != -1" @click="scanCode('8')">
            <div class="h_fun_list_icon l_i_9"></div>
            <p>装配品管扫码</p>
          </div>
          <!--重新下发-->
          <div class="h_fun_list" v-show="pos.indexOf('9') != -1" @click="scanCode('9')">
            <div class="h_fun_list_icon l_i_10"></div>
            <p>重新下发</p>
          </div>
        </div>
      </div>
    </div>
    <!--查询-->
    <div class="h_fun_list_bg h_fun_list_bg2" v-show="pos.indexOf('10') != -1">
      <div class="h_fun_list_box">
        <!--标题-->
        <div class="h_fun_list_title">
          <p>查询</p>
        </div>
        <!--九宫格-->
        <div class="h_fun_list_w">
          <!--单号查询-->
          <router-link to="/orderCheck">
            <div class="h_fun_list">
              <div class="h_fun_list_icon l_i_11"></div>
              <p>单号查询</p>
            </div>
          </router-link>
          <!--日期查询-->
          <router-link to="/dateCheck">
            <div class="h_fun_list">
              <div class="h_fun_list_icon l_i_12"></div>
              <p>日期查询</p>
            </div>
          </router-link>
          <!--仓库查询-->
          <router-link to="/depotCheck">
            <div class="h_fun_list">
              <div class="h_fun_list_icon l_i_13"></div>
              <p>仓库查询</p>
            </div>
          </router-link>

          <router-link to="/unCheckIn">
            <div class="h_fun_list">
              <div class="h_fun_list_icon l_i_14"></div>
              <p>未入库编号查询</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!--退出确认键-->
    <div class="js_dialog" id="iosDialog1" ref="iosDialog1" style="display: none;">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">提示</strong></div>
        <div class="weui-dialog__bd">请确认退出登录</div>
        <div class="weui-dialog__ft">
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="cancel">取消</a>
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="comfirnLogOut">确认</a>
        </div>
      </div>
    </div>
    <!--退出登录-->
    <div class="h_fun_list_bg h_fun_list_bg2" @click="logOut()">
      <input class="logoutBtn" type="button" value="退出登录">
    </div>
    <loading v-show="loading"></loading>
    <success v-show="success"></success>

  </div>
</template>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import success from  '@/components/success'
  import loading from '@/components/loading'
  export default {
    name:'home',
    components:{
      loading,
      success
    },
    data(){
      return{
//        用户信息
        userMsg:'',
//        权限
        pos:'',
//        初始化
        loading:false,
        success:false,
        scanDetail:'',
        orderData:'',
      }
    },
    created:function () {
      var that = this;
      var token = localStorage.getItem('token');
      var formData = new FormData();
      var url = window.location.href.split('#')[0];
      formData.append('token',token);
      that.loading = true;
      that.app.postData('/mhome.php/User/getUserInfo',formData
        ,result =>{
          that.userMsg = result.content;
          that.pos = result.content.permission_list;
          if( that.pos == null ){
            that.pos = '';
          }
        },()=>{
          that.loading = false;
        });
//    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      检查机型
      checkPhone(index){
        var that = this;
//      ios手机
        if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
          that.scanCode(index);
//          return false;
        }else{
//       Android手机
          that.scanCode(index);
        }
      },
//      扫码
      scanCode(index){
        var that = this;
        var token = localStorage.getItem('token');
        var formData = new FormData();
        formData.append('token',token);
        wx.ready(function () {
          // 在这里调用 API
          wx.checkJsApi({
            jsApiList: ['scanQRCode'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function(res) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
          });
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
              var codeRes = JSON.parse(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
              var order_id = codeRes.order_id;
              var size_id = codeRes.size_id;
              var no = codeRes.no;
              formData.append('order_id',order_id);
              formData.append('no',no);
//              扫码查询
              if( index == '0' ){
                that.$router.push({ name:'scanDetail',query:{ order_id:order_id,size_id:size_id,no:no,type:'check' } });
              }
//              针车中仓入库
              if( index == '1' ){
                formData.append('size_id',size_id);
                that.app.postData('/mhome.php/Order/part1InScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              针车中仓出库
              if( index == '2' ){
                that.app.postData('/mhome.php/Order/part1OutScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              成型中仓入库
              if( index == '3' ){
                that.app.postData('/mhome.php/Order/part2InScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              成型中仓出库
              if( index == '4' ){
                that.app.postData('/mhome.php/Order/part2OutScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              成品库入库
              if( index == '5' ){
                that.app.postData('/mhome.php/Order/part3InScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              针车品管扫码
              if( index == '6' ){
                formData.append('size_id',size_id);
                that.app.postData('/mhome.php/Order/part1QCScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              成型品管扫码
              if( index == '7' ){
                that.app.postData('/mhome.php/Order/part2QCScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              装配品管扫码
              if( index == '8' ){
                that.app.postData('/mhome.php/Order/part3QCScan',formData
                  ,result =>{
                    if( result.status == 200 ){
                      that.success = true;
                      var phone = setTimeout(function () {
                        that.success = false;
                        that.checkPhone(index);
                      },1000);
                    }
                    if( result.status == 503 ){
                      webToast(result.message,'middle',1500);
                    }
                  });
              }
//              重新下发
              if( index == '9' ){
                that.$router.push({ name:'scanDetail',query:{ order_id:order_id,size_id:size_id,no:no,type:'rs' } });
              }
            }
          });
        });
      },
//      退出登录
      logOut(){
        var that = this;
        that.$refs.iosDialog1.style.display = 'block';
      },
//      确认退出
      comfirnLogOut(){
        var that = this;
        localStorage.removeItem('token');
        that.$refs.iosDialog1.style.display = 'none';
        that.loading = true;
        var jumpLogin = setTimeout(function () {
          that.$router.push({ path:'/login' })
        },1000)
      },
//      取消退出
      cancel(){
        var that = this;
        that.$refs.iosDialog1.style.display = 'none';
      },
    },
    beforeRouteEnter(to,from,next){
      window.document.body.style.background  = '#f4f4f4';
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.document.body.style.background = '';
      next();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home.vue